// ##### Komarov 2025-05-26
import React from 'react';
// ##### 25-05-21 Komarov
import CartDetails from './CartDetails';
import ClientDetails from './ClientDetails';
// ##### Komarov 2025-05-26

// ##### Komarov 2025-07-14
const ContentWrapperDiv = ({ formClassName, cartClass }) => {
  // ##### Komarov 2025-05-26
  return (
    <>
      <ClientDetails formClassName={formClassName} />
      { /* ##### Komarov 2025-07-21 */}
      <CartDetails cartClass={cartClass} />
    </>
  );
};

export default ContentWrapperDiv;
